import React from "react";
import { Grid, useTheme } from "@mui/material";
import { Container, Title } from "@components/InputCst/InputWrapper/style";

interface InputWrapperProps {
  label: string;
  children: React.ReactNode;
}

const InputWrapper: React.FC<InputWrapperProps> = ({ label, children }) => {
  const theme = useTheme();
  return (
    <Grid item xs={12}>
      <Container theme={theme}>
        <Title variant="caption" theme={theme}>
          {label}
        </Title>
        <Grid container spacing={3}>
          {children}
        </Grid>
      </Container>
    </Grid>
  );
};

export default InputWrapper;
